/** Authored AoE item ids shared by placement and presentation, without loading the placement engine. */
export const SHAPES: Record<string, string> = {
  '981032B8-4F0B-43C9-8D98-67C693E4DB42': 'sphere',
  'C53BE2B6-07EA-4B3B-9664-1AD286C44AF9': 'circle',
  'E8B770D7-1BC3-4035-A29C-B99047884CC1': 'cylinder',
  '0DBFA54E-F921-4835-B159-2A4AEFA62408': 'cube',
  '3F14BF23-09A6-4C05-AFD9-EE0CCD2596A3': 'square',
  '56D1C490-B589-4B17-889A-59D866E38D54': 'line',
  '0FEF0148-6B62-4601-A8A1-A5A1A22905D8': 'cone',
};
